import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../../assets/img/logo_macizo.png';

let imageBase64;
let xhr = new XMLHttpRequest();
xhr.open('GET', logo, true);
xhr.responseType = 'blob';
xhr.onload = function(e) {
	let reader = new FileReader();
	reader.onload = function(event) {
		imageBase64 = event.target.result;
	};
	let file = this.response;
	reader.readAsDataURL(file);
};
xhr.send();

// Used in Reports View.
var doc;
function headerPDF() {
	let logo = imageBase64;
	doc = new jsPDF({
		orientation: 'p',
		unit: 'mm',
		format: 'a4',
		hotfixes: [] // an array of hotfix strings to enable
	});
	doc.addImage(logo, 'JPEG', 20, 20, 30, 30);
	doc.setFontSize(16);
	doc.text(55, 25, 'MACIZO');
	doc.setFontSize(12);
	doc.setFont('helvetica');
	//doc.setFontType("bold");
}
function headerPDF_vertical() {
	let logo = imageBase64;
	doc = new jsPDF({
		orientation: 'l',
		unit: 'mm',
		format: 'a4',
		hotfixes: [] // an array of hotfix strings to enable
	});
	doc.addImage(logo, 'JPEG', 20, 20, 30, 30);
	doc.setFontSize(16);
	doc.text(55, 25, 'MACIZO');
	doc.setFontSize(12);
	doc.setFont('helvetica');
	//doc.setFontType("bold");
}
export function unidades_producidas(data, Year, Month) {
	return (dispatch) => {
		headerPDF();

		doc.text(55, 40, `Reporte unidades producidas`);
		doc.text(55, 50, `Año: ${Year} / Mes: ${Month}`);

		doc.autoTable({
			startY: 55,
			head: [ [ 'Dia', 'Articulo', 'Cantidad', 'Planta' ] ],
			body: data,
			theme: 'striped'
		});

		doc.save('Reporte unidades producidas.pdf');
	};
}

export function PDF_ExistenciaActual(data, date) {
	return (dispatch) => {
		headerPDF();

		doc.text(55, 40, `Reporte unidades producidas`);
		doc.text(55, 50, `Fecha: ${date}`);

		doc.autoTable({
			startY: 55,
			head: [ [ 'Planta', 'Codigo', 'Descripcion', 'Disponible', 'Fraguado', 'En proceso' ] ],
			body: data,
			theme: 'striped'
		});

		doc.save('Reporte existencia actual.pdf');
	};
}

export function PDF_DespachosDiarios(data, year) {
	return (dispatch) => {
		headerPDF();

		doc.text(55, 40, `Reporte despachos diarios`);
		doc.text(55, 50, `Año: ${year}`);

		doc.autoTable({
			startY: 55,
			head: [
				[
					'Fecha',
					'Familia',
					'Cantidad Viaje',
					'Despachos Clientes',
					'Despachos Macizo',
					'Total Despachos',
					'Unidades Producidas'
				]
			],
			body: data,
			theme: 'striped'
		});

		doc.save('Reporte despachos diarios.pdf');
	};
}

export function PDF_DespachosDiariosDetallados(data, year, month, planta) {
	return (dispatch) => {
		headerPDF();

		doc.text(55, 40, `Reporte despachos diarios detallados`);
		doc.text(55, 50, `Año: ${year} , Mes:${month}, planta:${planta}`);

		doc.autoTable({
			startY: 55,
			head: [
				[
					'Codigo',
					'Descripcion',
					'Total',
					'Participacion',
					'Promedio',
					'D1',
					'D2',
					'D3',
					'D4',
					'D5',
					'D6',
					'D7',
					'D8',
					'D9',
					'D10',
					'D11',
					'D12',
					'D13',
					'D14',
					'D15',
					'D16',
					'D17',
					'D18',
					'D19',
					'D20',
					'D21',
					'D22',
					'D23',
					'D24',
					'D25',
					'D26',
					'D27',
					'D28',
					'D29',
					'D30',
					'D31'
				]
			],
			body: data,
			theme: 'striped'
		});

		doc.save('Reporte despachos diarios detallados.pdf');
	};
}

export function PDFReporte(data, columns, name) {
	let columnas = [];
	columns.forEach((element) => {
		columnas.push(element.Header);
	});
	return (dispatch) => {
		headerPDF();

		doc.text(55, 40, `${name}`);
		//	doc.text(55, 50, `from date: ${from} / to date: ${to}`);

		doc.autoTable({
			startY: 55,
			head: [ columnas ],
			body: data,
			theme: 'striped'
		});

		doc.save('"' + name + '".pdf');
	};
}

export function PDFReporte_2(data, columns, name) {
	let columnas = [];
	columns.forEach((element) => {
		columnas.push(element.Header);
	});
	return (dispatch) => {
		headerPDF_vertical();

		doc.text(55, 40, `${name}`);
		//	doc.text(55, 50, `from date: ${from} / to date: ${to}`);

		doc.autoTable({
			startY: 55,
			head: [ columnas ],
			body: data,
			theme: 'striped'
		});

		doc.save('"' + name + '".pdf');
	};
}
